

import React from "react";

export default function ChooseCity({
    allCountries,
    selectedArea,
    selectedCity,
    setSelectedCity,
}) {
    let hasArea = false;
    return (
        <div className="pb-3">
            <h4 className="font-semibold pb-2 text-white">Choose city</h4>
            <select onChange={(e)=>setSelectedCity(e.target.value)} value={selectedCity} className="select select-accent bg-[#272737] text-white w-full border border-gray-600">
                <option value="">Select one</option>
                {allCountries &&
                    allCountries.map((area, index) => {
                        if (
                            area.parent === parseInt(selectedArea)
                        ) {
                            hasArea = true;
                            return (
                                <option
                                    key={index}
                                    value={area.id}
                                >
                                    {area.name}
                                </option>
                            );
                        }
                        return null;
                    })}
                    {!hasArea && selectedArea && allCountries && allCountries.map((parentCountry, index) => {
                        if (parentCountry.id === parseInt(selectedArea)) {
                            return(
                                <option
                                    key={index}
                                    value={parentCountry.id}
                                >
                                    {parentCountry.name}
                                </option>
                            )
                        }
                    })}
            </select>
        </div>
    );
}
/*
import React, { Component } from 'react';

import CreatableSelect from 'react-select/creatable';
import { ColourOption, colourOptions } from '../data';
import { ActionMeta, OnChangeValue } from 'react-select';

export default class CreatableSingle extends Component {

  handleInputChange = (inputValue, actionMeta) => {
    console.group('Input Changed');
    console.log(inputValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
  };
  render() {
    return (
      <CreatableSelect
        isClearable
        onChange={this.handleChange}
        onInputChange={this.handleInputChange}
        options={colourOptions}
      />
    );
  }
}

*/